export default __webpack_public_path__ + "static/work-hero-4c7fe21a1e660fd2055e4fccb98b1ef1.png";